import { createContext, PropsWithChildren, useContext } from 'react'
import { ServerExperiments } from '@/experimentation'

export const TicketsLandingContext = createContext<ServerExperiments | null>(null)

interface TicketsLandingContextProviderProps extends PropsWithChildren {
  experiments: ServerExperiments
}

export const TicketsLandingContextProvider: React.FC<TicketsLandingContextProviderProps> = ({
  children,
  experiments,
}) => {
  return <TicketsLandingContext.Provider value={experiments}>{children}</TicketsLandingContext.Provider>
}

export const useTicketsLandingContext = () => {
  return useContext(TicketsLandingContext)
}
